(function () {
  'use strict';
  if (window.__rhlRemoveFeedback) return;
  window.__rhlRemoveFeedback = true;
  var pending = false;

  function message(drawer, text) {
    var status = drawer.querySelector('[data-rhl-remove-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.rhlRemoveStatus = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      drawer.querySelector('.hdt-dialog-drawer__header').after(status);
    }
    status.textContent = text;
    status.className = text ? 'rhl-cart-remove-message' : 'sr-only';
  }

  document.addEventListener('click', async function (event) {
    var drawer = event.target.closest && event.target.closest('#CartDrawer');
    if (!drawer) return;
    var link = event.target.closest('.hdt-mini-cart__remove');
    // Block repeated removal, stale line-index quantity changes and navigation
    // to the enquiry form until the authoritative cart has finished rendering.
    if (pending && event.target.closest('cart-items-component, .rhl-cart-footer-actions')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (!link || !window.RHLCartSync) return;
    var row = link.closest('[data-rhl-cart-line]');
    if (!row || !row.dataset.rhlCartLine) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    pending = true;
    var key = row.dataset.rhlCartLine;
    var items = row.closest('cart-items-component');
    var wasInert = items.inert;
    items.inert = true;
    var name = row.querySelector('.hdt-mini-cart__title').textContent.trim();
    var button = row.querySelector('.hdt-mini-cart__img');
    var overlay = document.createElement('span');
    overlay.className = 'rhl-cart-remove-loader';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<span></span>';
    button.appendChild(overlay);
    row.classList.add('rhl-cart-removing');
    row.setAttribute('aria-busy', 'true');
    drawer.setAttribute('data-rhl-removal-pending', '');
    link.setAttribute('aria-disabled', 'true');
    message(drawer, 'Removing ' + name + '\u2026');
    var removed = false;
    var animation;
    try {
      await window.RHLCartSync.run(async function () {
        var root = (window.Shopify && Shopify.routes.root) || '/';
        var response = await fetch(root + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // Use the immutable line key, never an index which can shift.
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        var cart = await response.json();
        if (!response.ok || cart.errors || !Array.isArray(cart.items) || cart.items.some(function (item) { return item.key === key; })) {
          throw new Error('Could not remove this item. Please try again.');
        }
        removed = true;
        if (row.isConnected && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          animation = row.animate([
            { opacity: 1, height: row.getBoundingClientRect().height + 'px' },
            { opacity: 0, height: '0px', marginTop: '0px', marginBottom: '0px', paddingTop: '0px', paddingBottom: '0px' }
          ], { duration: 180, easing: 'ease-in-out', fill: 'forwards' });
          await animation.finished;
        }
        var confirmed = await window.RHLCartSync.sync({ source: 'rhl-cart-remove' });
        if (confirmed.items.some(function (item) { return item.key === key; })) throw new Error('Removal has not been confirmed. Please reopen your enquiry list.');
      });
      message(drawer, '');
      items.inert = wasInert;
      // Preserve keyboard focus after the removed control is replaced.
      if (event.detail === 0) {
        var next = drawer.querySelector('.hdt-mini-cart__remove, [data-dialog-close], button[aria-label*="Close"]');
        if (next) next.focus({ preventScroll: true });
      }
    } catch (_) {
      message(drawer, removed ? 'Your item was removed. Please reopen the enquiry list to refresh it.' : 'Could not confirm removal. Please reopen your enquiry list to check before trying again.');
    } finally {
      if (animation) animation.cancel();
      overlay.remove();
      row.classList.remove('rhl-cart-removing');
      row.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
      drawer.removeAttribute('data-rhl-removal-pending');
      items.inert = wasInert;
      pending = false;
    }
  }, true);
})();
